module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-chefs-course-3334e27f6c68ecbebacebb70437cb9ef.png";